<template>
  <div id="page">
    <b-container class="text-left">
      <b-list-group>
        <b-list-group-item class="text-left">
          <div>订单状态</div>
          <p class="mb-1">
            <b>{{ order.orderStatus }}</b>
          </p>
        </b-list-group-item>

        <b-list-group-item class="text-left">
          <div>订单编号</div>
          <p class="mb-1">
            <b>{{ order.orderNo }}</b>
          </p>
        </b-list-group-item>

        <b-list-group-item class="text-left">
          <div>卡片名称</div>
          <p class="mb-1">
            <b>{{ order.cardTypeName }}</b>
          </p>
        </b-list-group-item>

        <b-list-group-item class="text-left">
          <div>申请日期</div>
          <p class="mb-1">
            <b>{{ order.orderDateTime }}</b>
          </p>
        </b-list-group-item>

        <b-list-group-item class="text-left">
          <div>邮寄地址</div>
          <p class="mb-1">
            <b>{{ order.address }}</b>
          </p>
        </b-list-group-item>
      </b-list-group>

      <div class="box" v-show="false">
        <b-col>
          <b-button block variant="outline-danger" @click="cancelOrder()"
            >取消订单</b-button
          >
        </b-col>
        <b-col>
          <b-button block variant="outline-primary" @click="reupload()"
            >重新上传卡面</b-button
          >
        </b-col>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "OrderDetails",
  data() {
    return {
      projectName: "",
      order: "",
    };
  },
  methods: {
    cancelOrder: function () {
      var that = this;
      var param = {
        orderNo: this.order.orderNo,
      };
      axios
        .post("https://cp.hengbao.net.cn:9010/pos/order/refund", param)
        .then(function (response) {
          console.log(response);
          var data = response.data;
          if (data.code === 0) {
            setTimeout(function () {
              that.$router.go(-3);
            });
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reupload: function () {
      var param = {
        isModify: 1,
        orderNo: this.order.orderNo,
        backgroundColor: this.order.backgroundColor,
        cardOri: this.order.cardTypographyId,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "SelectCardface",
        params: {
          selectParam: selectParam,
        },
      });
    },
  },
  mounted: function () {
    /* {
        "projectName": "DIY",
        "order": {
          "orderNo": "01222404618637029376",
          "orderDateTime": "2020-03-10 14:12:50",
          "orderStatus": "制卡完成",
          "orderStatsNo": 8,
          "courierCompany": "",
          "trackNumber": "",
          "orderType": "1",
          "price": 1,
          "auditFailCause": null,
          "modelType": 0,
          "modelClass": 0,
          "backgroundColor": "201C",
          "cardClass": 1,
          "address": "北京市西城区新盛大厦B-8层",
          "orderStep": 3,
          "cardTypeName": "借记卡",
          "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
        }
      } */
    var orderItem = this.$route.params.orderItem;
    console.log("orderItem:" + orderItem);
    var orderItemObj = JSON.parse(orderItem);
    this.projectName = orderItemObj.projectName;
    this.order = orderItemObj.order;
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetails.vue